import "../../scss/pages/main.scss";
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import ToggleDarkMode from "../helpers/ToggleDarkMode";

const Cookies = require('js-cookie');

function getDropdown() {
	return import('bootstrap/js/dist/dropdown')
		.then()
		.catch(() => 'An error occurred while loading the component');
}

getDropdown().then();

function getTooltip() {
	return import('bootstrap/js/dist/tooltip')
		.then()
		.catch(() => 'An error occurred while loading the component');
}

getTooltip().then();

function getPopover() {
	return import('bootstrap/js/dist/popover')
		.then()
		.catch(() => 'An error occurred while loading the component');
}

getPopover().then();

export default class main {
	constructor() {
		this.switchColorMode = document.querySelector('#switchColorMode');
		this.toggleColorModeElement = document.querySelector('#toggleColorMode');
		this.html = document.querySelector('html');
		this.selectedLocale = document.querySelector('#dropdownlanguageMenu');
		this.currentDomain = window.location.host;
	}
	
	toggleColorModeIcon(colorModeButtonElement, isOnChange = false) {
		const circleToggleElement = colorModeButtonElement.querySelector('.circle-toggle');
		if (colorModeButtonElement.dataset.colorMode === 'dark') {
			circleToggleElement.classList.replace('toggle-light', 'toggle-dark');
			circleToggleElement.classList.replace('fa-sun-bright', 'fa-moon');
			
			if (isOnChange) {
				circleToggleElement.classList.add('anim-light');
				circleToggleElement.classList.remove('anim-dark');
			}
			
		} else {
			circleToggleElement.classList.replace('toggle-dark', 'toggle-light');
			circleToggleElement.classList.replace('fa-moon', 'fa-sun-bright');
			if (isOnChange) {
				circleToggleElement.classList.add('anim-dark');
				circleToggleElement.classList.remove('anim-light');
			}
		}
	}
	
	/**
	 * change color theme after first load on web app iframe
	 * @param colorTheme - string
	 */
	getIframeReady(colorTheme) {
		window.addEventListener("message", function (event) {
			if (event.origin === "https://ws.nperf.com" || event.origin === "https://ws-cdn.nperf.com"
				|| event.origin === "http://ws-nossl.nperf.com") {
				try {
					if (event.data.action === "nPerfLoaded") {
						if (document.getElementById('nPerfSpeedTest')) {
							document.getElementById('nPerfSpeedTest').contentWindow.postMessage({
								action: 'nPerfSetTheme',
								theme: colorTheme
							}, "*");
						}
					}
				} catch (e) {
					console.debug(e) // eslint-disable-line
				}
				
			}
		});
		
	}
	
	/**
	 * remove cookie of a specific domain
	 * @param cookieName - string
	 * @param value - string
	 * @param options
	 */
	removeCookie(cookieName, value, options = {path: '/', domain: this.currentDomain}) {
		if (Cookies.get(cookieName, value, options)) {
			Cookies.remove(cookieName, value, {path: '/', domain: this.currentDomain});
		}
	}
	
	getSharedCookieDomainOption() {
		return { path: '/', domain: '.nperf.com', expires: 7, secure: true, sameSite: 'Lax'};
	}
	
	/**
	 * Set html color mode and enable/disable switch
	 * @param colorTheme - string
	 */
	setColorMode(colorTheme) {
		this.html.dataset.theme = colorTheme;
		this.toggleColorModeElement.dataset.colorMode = colorTheme;
		this.removeCookie('theme', colorTheme);
		this.removeCookie('theme', colorTheme, {path: '/', domain: '.nperf.com', expires: 'Session'});
		Cookies.set('theme', colorTheme, this.getSharedCookieDomainOption());
		this.toggleColorModeIcon(this.toggleColorModeElement);
		this.getIframeReady(colorTheme);
	}
	
	/**
	 * toggle color mode via input checkbox
	 * @param event
	 */
	onchangeColorMode(event) {
		
		const newColorMode = event.target.dataset.colorMode === 'light' ? 'dark' : 'light';
		
		this.toggleColorModeIcon(event.target, true);
		
		event.target.dataset.colorMode = newColorMode;
		this.setColorMode(newColorMode);
		if (document.getElementById('nPerfSpeedTest')) {
			document.getElementById('nPerfSpeedTest').contentWindow.postMessage({
				action: 'nPerfSetTheme',
				theme: newColorMode
			}, "*");
		}
		
		/* eslint-disable */
		_paq.push(['trackEvent', 'theme_mode', 'switch_theme_mode', newColorMode]);
		/* eslint-enable */
	}
	
	/**
	 * toggle color mode depending on OS color setting
	 */
	autoChangeColorMode() {
		if (Cookies.get('theme')) {
			this.setColorMode(Cookies.get('theme'));
		} else {
			if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
				this.setColorMode('dark');
			} else {
				this.setColorMode('light');
			}
		}
	}
	
	/**
	 * active item category and sub category depending on which active page
	 */
	selectActiveItemMenu() {
		const navItemList = document.querySelectorAll('.navbar-nav li.nav-item');
		const itemMenuActive = document.querySelector('.item-menu-active');
		if (itemMenuActive) {
			const itemMenuActiveParent = itemMenuActive.closest('li.nav-item');
			Array.from(navItemList).forEach((navItem) => {
				if (navItem === itemMenuActiveParent) {
					itemMenuActiveParent.classList.add('category-menu-active');
				} else {
					navItem.classList.remove('category-menu-active');
				}
			});
		}
	}
	
	setLanguageCookie() {
		this.removeCookie('language', this.selectedLocale.dataset.languageSelected);
		Cookies.set('language', this.selectedLocale.dataset.languageSelected, this.getSharedCookieDomainOption());
	}
	
}
window.nPerfLayout.main = new main();

document.addEventListener("DOMContentLoaded", function () {
	const mainModule = new main();
	const menuItemList = document.querySelectorAll('#collapsibleNavbar .sub-menu');
	const buttonPlatformList = document.querySelectorAll('#mainFooter .btn-platform');
	const buttonSocialFooterList = document.querySelectorAll('#mainFooter .btn-social-footer');
	const productCardsList = document.querySelectorAll('.products-banner .card-link');
	const lightModeImageList = document.querySelectorAll('.light-mode-img');
	const darkModeImageList = document.querySelectorAll('.dark-mode-img');
	const switchThemeMode = document.querySelector('#toggleColorMode');
	const solutionContactButtonList = document.querySelectorAll('.btn-contact-solution');
	const buttonPreConnect = document.querySelector('.btn-pre-connect');
	const buttonCockpit = document.querySelector('.btn-cockpit');
	let colorToggle = document.getElementById('toggleColorMode');
	
	colorToggle.addEventListener("click", function (event) {
		mainModule.onchangeColorMode(event);
	});
	
	mainModule.setLanguageCookie();
	
	if (darkModeImageList.length > 0) {
		ToggleDarkMode.toggleImageMode(lightModeImageList, darkModeImageList);
		
		switchThemeMode.addEventListener('click', () => {
			ToggleDarkMode.toggleImageMode(lightModeImageList, darkModeImageList);
		});
	}
	
	$(".consentOk").on("click", function () {
		const now = new Date();
		const time = now.getTime();
		const expireTime = time + 1000 * 3600 * 24 * 365;
		const eulaVersion = document.querySelector('.consentOk').dataset.trans;
		now.setTime(expireTime);
		
		$("#consent").hide();
		document.cookie = `consent=${ eulaVersion };expires= ${ now.toGMTString() };path=/`;
	});
	
	if (top.location !== location) {
		top.location.href = document.location.href;
	}

	const loginForm = document.querySelector("[name=login-form]");
	loginForm?.addEventListener('submit', event => event.preventDefault());
	loginForm?.addEventListener('click', event => event.stopPropagation());
	
	const dropdownButton = document.querySelector('.layout-menu .btn-dropdown');
	const body = document.querySelector('body');
	dropdownButton.addEventListener('click', () => {
		const isExpanded = dropdownButton.getAttribute("aria-expanded") === "true";
    
		if (window.matchMedia("(max-width: 991.98px)").matches) {
			body.classList.toggle("overflow-hidden", isExpanded);
		} else if (body.classList.contains("overflow-hidden")) {
			body.classList.remove("overflow-hidden");
		}
	});

	const buttonLogout = document.querySelector('.btn-logout');
	
	if (buttonLogout) {
		buttonLogout.addEventListener('click', () => {
			import('../components/modal')
				.then((module) => {
					const modalModule = new module.Modal();
					modalModule.logout();
				})
				.catch((error) => {
					console.error("Error loading module:", error);
				});
		});
	}
	
	if (buttonPreConnect) {
		buttonPreConnect.addEventListener('click', () => {
			import('../components/modal').then();
		});
	}
	
	if (buttonCockpit) {
		buttonCockpit.addEventListener('click', () => {
			/* eslint-disable */
			_paq.push(['trackEvent', 'cockpitAccount', buttonCockpit.dataset.tag]);
			/* eslint-enable */
		});
	}
	
	const paramsAllowedToOpenModal = [
		'account',
		'forgotPassword',
		'pkey',
		'mkey',
		'vkey'
	]
	
	const searchParams = new URLSearchParams(window.location.search);
	searchParams.forEach((value, key) => {
		if (paramsAllowedToOpenModal.includes(key)) {
			import('../components/modal').then();
		}
	});
	
	mainModule.selectActiveItemMenu();
	mainModule.autoChangeColorMode();
	
	menuItemList.forEach((menuItem) => {
		menuItem.addEventListener('click', () => {
			/* eslint-disable */
			_paq.push(['trackEvent', 'Menu', menuItem.dataset.tag]);
			/* eslint-enable */
		})
	});
	
	buttonPlatformList.forEach((buttonPlatform) => {
		buttonPlatform.addEventListener('click', () => {
			/* eslint-disable */
			_paq.push(['trackEvent', 'Footer', buttonPlatform.dataset.tag]);
			/* eslint-enable */
		})
	});
	
	buttonSocialFooterList.forEach((buttonSocialFooter) => {
		buttonSocialFooter.addEventListener('click', () => {
			/* eslint-disable */
			_paq.push(['trackEvent', 'Footer', buttonSocialFooter.dataset.tag]);
			/* eslint-enable */
		})
	});
	
	productCardsList.forEach((productCard) => {
		productCard.addEventListener('click', () => {
			/* eslint-disable */
			_paq.push(['trackEvent', 'ProductCard', productCard.dataset.tag]);
			/* eslint-enable */
		})
	});
	
	if (solutionContactButtonList.length > 0) {
		solutionContactButtonList.forEach((solutionContactButton) => {
			solutionContactButton.addEventListener('click', () => {
				/* eslint-disable */
				_paq.push(['trackEvent', 'Contact', solutionContactButton.dataset.tag]);
				/* eslint-enable */
			})
		});
	}
	
});